import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { useMatch, useNavigate } from 'react-router-dom'

export type QuizAnalyticsTab = 'overview' | 'learners'

let tabRoutes: Record<QuizAnalyticsTab, string> = {
  overview: '/manage/quiz-analytics',
  learners: '/manage/quiz-analytics/learners',
}

export let QUIZ_ANALYTICS_TABPANEL_ID = 'quiz-analytics-tabpanel'

export let quizAnalyticsTabID = (tab: QuizAnalyticsTab) =>
  `quiz-analytics-tab-${tab}`

// Exact match on the Learners route, so a quiz ID that happens to contain
// "learners" never selects the wrong tab.
export let useQuizAnalyticsTab = (): QuizAnalyticsTab =>
  useMatch(tabRoutes.learners) ? 'learners' : 'overview'

export default function QuizAnalyticsTabs() {
  let navigate = useNavigate()
  let activeTab = useQuizAnalyticsTab()

  return (
    <Tabs
      value={activeTab}
      onChange={(_, value: QuizAnalyticsTab) => navigate(tabRoutes[value])}
      aria-label="Quiz analytics views"
      variant="scrollable"
      scrollButtons="auto"
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      <Tab
        id={quizAnalyticsTabID('overview')}
        aria-controls={QUIZ_ANALYTICS_TABPANEL_ID}
        value="overview"
        label="Overview"
      />
      <Tab
        id={quizAnalyticsTabID('learners')}
        aria-controls={QUIZ_ANALYTICS_TABPANEL_ID}
        value="learners"
        label="Learners"
      />
    </Tabs>
  )
}
